import React from 'react';


const ActivityChart = ({ data }) => {
  const maxRevenue = Math.max(...data?.map(d => d?.revenue || 0));

  return (
    <div className="bg-card border border-border rounded-xl p-6 shadow-sm">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground">Activity Overview</h3>
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full bg-primary"></div>
            <span className="text-sm text-muted-foreground">Transactions</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full bg-success"></div>
            <span className="text-sm text-muted-foreground">Revenue</span>
          </div>
        </div>
      </div>

      {/* Chart */}
      <div className="space-y-4">
        {data?.map((item, index) => (
          <div key={index} className="space-y-2">
            <div className="flex items-center justify-between text-sm">
              <span className="text-muted-foreground">{item?.date}</span>
              <div className="flex items-center gap-4">
                <span className="text-primary font-medium">{item?.transactions} txn</span>
                <span className="text-success font-medium">Rp {item?.revenue?.toLocaleString('id-ID')}</span>
              </div>
            </div>
            <div className="flex gap-2">
              <div className="flex-1 bg-muted rounded-full h-2 overflow-hidden">
                <div
                  className="h-full bg-primary rounded-full transition-all"
                  style={{ width: `${(item?.transactions / 10) * 100}%` }}
                ></div>
              </div>
              <div className="flex-1 bg-muted rounded-full h-2 overflow-hidden">
                <div
                  className="h-full bg-success rounded-full transition-all"
                  style={{ width: `${maxRevenue > 0 ? (item?.revenue / maxRevenue) * 100 : 0}%` }}
                ></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActivityChart;